import api from './client';
import { API_ENDPOINTS } from './endpoints';

export interface VersionHistoryApiItem {
  version_number?: string;
  update_title?: string;
  update_description?: string;
  updated_at?: string;
}

export interface VersionApiItem {
  version_number?: string;
  update_title?: string;
  update_description?: string;
  last_updated_at?: string;
  previous_updates?: VersionHistoryApiItem[];
  createdAt?: string;
  updatedAt?: string;
}

export interface VersionDataResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?:
    | VersionApiItem
    | {
        version?: VersionApiItem;
        item?: VersionApiItem;
        current?: VersionApiItem;
      };
}

export const getVersionData = async (): Promise<VersionDataResponse> => {
  return api.get<VersionDataResponse>(API_ENDPOINTS.dashboard.version);
};

// `date` ('YYYY-MM-DD') on trend arrays feeds the Dashboard's date-range
// filter (see src/utils/dashboardFilters.ts) — include it once this endpoint
// is wired up for real, or those rows just won't respond to the filter.
export interface DashboardStatsResponse {
  success: boolean;
  statusCode: number;
  message: string;
  data?: {
    kpiCards?: Array<{ label: string; value: number | string; change?: number; changeLabel?: string }>;
    departmentVolumeData?: Array<{ department: string; assigned: number; completed: number; pending: number }>;
    ticketStatusDistribution?: Array<{ name: string; value: number }>;
    priorityWiseTickets?: Array<{ priority: string; count: number }>;
    moduleTaskDistribution?: Array<{ name: string; value: number }>;
    userAssignedVsCompleted?: Array<{ user: string; assigned: number; completed: number; pending: number }>;
    agingBucketData?: Array<{ bucket: string; count: number }>;
    taskCreatedVsClosed?: Array<{ week: string; date: string; created: number; closed: number }>;
    overdueTasksByUser?: Array<{ user: string; overdue: number }>;
    deptPendingTickets?: Array<{ department: string; open: number; inProgress: number; pending: number }>;
    monthlyPerformanceTrend?: Array<{ month: string; date: string; productivity: number; accuracy: number; tat: number }>;
    statusComparisonData?: Array<{ month: string; date: string; completed: number; pending: number; rejected: number }>;
    actualVsTargetData?: Array<{ department: string; actual: number; target: number }>;
    performanceTrendData?: Array<{ period: string; date: string; completed: number; target: number; accuracy: number }>;
    paymentPostingTrend?: Array<{ month: string; date: string; posted: number; adjustments: number; target: number }>;
    payerWiseData?: Array<{ payer: string; claims: number; posted: number; denied: number }>;
    slaMissedData?: Array<{ department: string; met: number; missed: number }>;
    auditScoreByUser?: Array<{ user: string; accuracy: number; rework: number; audited: number }>;
    approvalFlowData?: Array<{ name: string; value: number }>;
    userPaymentPosting?: Array<{ user: string; posted: number; era: number }>;
  };
}

export const getDashboardStats = async (): Promise<DashboardStatsResponse> => {
  return api.get<DashboardStatsResponse>(API_ENDPOINTS.dashboard.stats);
};
